<template>
    <async-table-action-button :callback="ComfirmAndDelete" :label="trans('buttons.delete')" :grid="grid">
        <inline-svg
            :url="require('../../../../images/actions/trash.svg')"
            classes="table-action-cell__icon"
        >
        </inline-svg>
    </async-table-action-button>
</template>

<script>
    import { EventBus } from '../../eventbus.js';
    import InlineSvg from '../../../util/inlineSvg.js'

    export default {
        props: ['url', 'confirmTitle', 'confirmText', 'errorFlashMessage', 'deleteId', 'grid'],

        components: {
            InlineSvg
        },

        methods: {
            ComfirmAndDelete() {
               this.$alertify.confirmWithTitle(
                    this.confirmTitle,
                    this.confirmText,
                    () => {
                        axios
                            .delete(this.url)
                            .then(response => {
                                if (response.data.success == true) {
                                    EventBus.$emit('onDelete', this.deleteId);

                                    this.flash({
                                        message: response.data.flash[0].message,
                                        level: 'success'
                                    });
                                } else {
                                    this.flash({
                                        message: response.data.flash[0].message,
                                        level: 'warning'
                                    });
                                }
                            })
                            .catch((error) => {
                                this.flash({
                                    message: error.response.data.error_message,
                                    level: 'warning'
                                });
                                if (this.errorFlashMessage) {
                                    this.flash({
                                        message: this.errorFlashMessage,
                                        level: 'warning'
                                    });
                                }
                            });
                    }
                );
            }
        }
    }
</script>
